export const STATUS_CODES = {
  CREATED: 'CREATED',
  DELAYED: 'DELAYED',
  NOTIFYING: 'NOTIFYING',
  READY_TO_PROCESS: 'READY_TO_PROCESS',
  IN_PROGRESS: 'IN_PROGRESS',
  EXECUTED: 'EXECUTED',
  CANCELLED: 'CANCELLED',
  REJECTED: 'REJECTED',
  DONE: 'DONE',
  APPROVED: 'APPROVED',
} as const;
